var _ = require('underscore');
const UrlService = require('../../util/url_service.js').default;
var SECTION_ID_SUFFIX = '-section';

/**
 * @ngInject
 */
function MyFontsController($window,
                           DataService,
                           FirstMileService,
                           I18nService,
                           TkWebProjectEditorService,
                           UserPrefsService) {
  this.DataService = DataService;
  this.I18nService = I18nService;
  this.$window = $window;
  this.TkWebProjectEditorService = TkWebProjectEditorService;
  this.UserPrefsService = UserPrefsService;
  this._loadSortModes();
  this._preloadData();
  this.TkWebProjectEditorService.populateCompleteWebProjectsData(1);
}

/**
 * Should we display the "empty" page view
 * (i.e., no families or web projects, depending on the tab)?
 * @return {Boolean}
 */
MyFontsController.prototype.isEmptyState = function() {
  if (!this.kitsData || !this.purchasedFonts) {
    return true;
  }

  if (this.isWebProjectsView()) {
    return !this.kitsData || this.kitsData.length === 0;
  }
  return this.isEmpty || this.purchasedFonts.length === 0;
};

/**
 * Is the current tab the "Purchased" tab?
 * @return {Boolean}
 */
MyFontsController.prototype.isPurchasedTab = function() {
  return this.currentTab && this.currentTab.id === 'purchased';
};

/**
 * Is the current tab the "Web Projects" tab?
 * @return {Boolean}
 */
MyFontsController.prototype.isWebProjectsView = function() {
  return this.currentTab && this.currentTab.id === 'web_projects';
};

/**
 * Update page state when a new tab is clicked.
 */
MyFontsController.prototype.onTabChanged = function() {
  // If it's the first page load, we already updated the filtered family list in _preloadData
  if (!this.isFirstPageLoad) {
    this.isTabChanging = true;
    if (this.isWebProjectsView()) {
      // Clear URL params for the filtered family list to show the correct URL
      UrlService.updatePath(UrlService.getWindowLocation().pathname + '#web_projects' + SECTION_ID_SUFFIX);
    }
  }
  this.isFirstPageLoad = false;
};

/**
 * Load the list of sort modes for the web projects.
 * @private
 */
MyFontsController.prototype._loadSortModes = function() {
  var self = this;
  self.DataService.get('web-project-sort-modes').then(function(sortModes) {
    self.sortModes = sortModes;
  });
};

/**
 * Preload data using DataService.
 * @private
 */
MyFontsController.prototype._preloadData = function() {
  var self = this;
  self.UserPrefsService.getUserPrefs().then(function() {
    self.DataService.get('/spectrum/preloaded_family_data').then(function (data) {
      self.isEmpty = data.isEmpty;
      self.purchasedFonts = data.familiesData.purchasedFonts;
      self.textSampleData = data.textSampleData;
      self.navigationTabs = data.navigationTabs;
      self._setCurrentTab();
      self._setExampleText();

      self.DataService.get('/my_fonts/i18n').then(function(i18n) {
        self._i18n = i18n;
      });

      self.DataService.get('family-sort-modes').then(function(familySortModes) {
        self.familySortModes = familySortModes;
      });
    });
  });

  self.DataService.get('/spectrum/kits_data').then(function(data) {
    if (data && data.kitsData) {
      self.TkWebProjectEditorService.initTkWebProjectListModel(data);
      self.kitsData = data.kitsData;
      var i;
      for (i = 0; i < self.kitsData.length; i++) {
        var kitData = self.kitsData[i];
        self.TkWebProjectEditorService.initTkWebProjectCardModel(kitData.kit.kit.token, kitData);
        self.TkWebProjectEditorService.initEmbedCodeModel(kitData.kit.kit.token, kitData.is_dynamic, kitData.project_embed_details);

        var j = 0;
        for (j = 0; j < kitData.tkff_list.length; j++) {
          var tkffData = kitData.tkff_list[j];
          // Id which considers both the kit token and the tkff id
          var id = kitData.kit.kit.token + tkffData.tkff.typekit_font_family.id;
          self.TkWebProjectEditorService.initTkWebProjectDisplayFamilyModel(
              id,
              tkffData.display_variation,
              tkffData.text_samples,
              tkffData.tktf_slug
          );
        }
      }
    }
  });
};

/**
 * Set correct tab
 * @private
 */
MyFontsController.prototype._setCurrentTab = function() {
  // Length of '-section' should be removed from the tabHash
  var self = this;
  var tabHash = self.$window.location.hash;
  var lengthToBeStripped = SECTION_ID_SUFFIX.length + 1;
  var tabId = tabHash.substr(1, tabHash.length - lengthToBeStripped);
  if (tabId.length !== 0) {
    self.navigationTabs.forEach(function (tab) {
      if (tab.id === tabId) {
        self.currentTab = tab;
      }
    });
  }
  if (self.currentTab === undefined) {
    self.isFirstPageLoad = true;
    self.currentTab = self.navigationTabs[0];
  }
};

/*
 * Sets example text based on language
 * @private
 */
MyFontsController.prototype._setExampleText = function() {
  // If any of the purchased fonts have a custom preview text set, then do not set example text
  if (this.purchasedFonts.length === 0 || this.purchasedFonts.some(font => font.preview_text?.content)) {
    return;
  }

  var self = this;
  var lang = _.first(_.uniq(_.pluck(self.purchasedFonts || [], 'default_language'))) || 'en';
  var textSample = self.textSampleData.textSamples[lang];
  self.exampleText = {
    value: self.kanaOnly ? textSample.list_kana : textSample.list,
    size: 36
  };
  self.featureSettings = textSample.feature_settings;
  self.unicodeRange = textSample.unicode_range;
};

module.exports = MyFontsController;
